// EmailValidationStore.ts
import { create } from "zustand";

type EmailValidationState = {
  isValid: boolean | null;
  error: string | null;
  setValidation: (state: { isValid: boolean; error: string | null }) => void;
  reset: () => void;
};

export const useEmailValidationStore = create<EmailValidationState>((set) => ({
  isValid: true,
  error: null,
  setValidation: (state) => set(state),
  reset: () => set({ isValid: null, error: null }),
}));
